export const TOTALS_ROW_HEIGHT = 64;
export const BREAKPOINT_DESKTOP_XL = 2000;

// using this number just to get the pct widths according to design https://www.figma.com/file/HGWOduOgmTKdqR0G87ODCn/Merit-Tier-0-Dashboard?node-id=130%3A7364
const TOTAL_WIDTH = 1688;
export const COLUMN_PADDING_HZ_PCT = 40 / TOTAL_WIDTH;
export const COLUMN_WIDTHS_PCT = [
  // time
  76,
  // headcount
  38,
  // work order & product
  452,
  // target
  120,
  // output
  120,
  // hourly performance
  438,
  // total downtime
  360,
].map(d => d / TOTAL_WIDTH);
export const VERTICAL_TIMELINE_PADDING_HZ = COLUMN_PADDING_HZ_PCT * TOTAL_WIDTH;

export const FORMAT_TIME = "HH:mm";

export function formatThousandsWithComma(num: number) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
